
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { store } from "../../storeLogistica";
import VueSelect from "vue-select";
import _ from "lodash";
import { mask } from "vue-the-mask";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";


export default {
  name: "app-mdfe-form-seguroTab",
  components: {
    VueSelect,
    Plus,
    TrashCanIcon,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      windowWidth: window.innerWidth,
      form: {
        compania: null,
        tipo_responsavel: null,
        cnpj_compania: null,
        apolice: null,
        responsavel_identificacao: null,
        averbacoes: [],
      },
      tipoResponsavelError: false,
      averbacaoToAdd: null,
      unidadeError: false,
      tiposResponsavel: [],
      unidadesPeso: [],
      fields: [
        {
          label: "Número",
          field: "numero",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
    ValidacaoMixin,
  ],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      const mdfeData = this.$route.params?.mdfeData?.mdfe;
      const [{ data: tipoResponsavelData }] = await Promise.all([
        this.$http.post('/mdfe/get-seguros-tipo'),
      ])
      this.tiposResponsavel = tipoResponsavelData;
      if(mdfeData){
        this.form.compania = mdfeData.seguro[0].compania;
        this.form.cnpj_compania = mdfeData.seguro[0].cnpj_compania;
        this.form.apolice = mdfeData.seguro[0].apolice;
        this.form.tipo_responsavel = tipoResponsavelData.find(responsavel => responsavel.id === mdfeData.seguro[0].tipo_responsavel)
        this.form.responsavel_identificacao = mdfeData.seguro[0].responsavel_identificacao;
        this.form.averbacoes = mdfeData.seguro[0].averbacoes;
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    validateState(field) {
      return !!this.form[field];
    },
    addAverbacao(averbacaoToAdd) {
      if (!averbacaoToAdd) return;
      this.form.averbacoes.push(averbacaoToAdd);
      this.averbacaoToAdd = null;
    },
    handleDeleteAverbacao(index) {
      this.form.averbacoes.splice(index, 1)
    },
  },
  created() {
    this.getDataInit();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 5
    }
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 6 && oldValue < newValue) {
        // if (!this.form.tipo_responsavel) {
        //   this.$toast.error('Tipo de responsavel obrigatorio!')
        //   this.tipoResponsavelError = true;
        //   this.store.currentTab = oldValue;
        // }
        // if (!this.form.compania) {
        //   this.$toast.error('Compania obrigatoria!')
        //   this.store.currentTab = oldValue;
        // }
        // if (!this.form.apolice) {
        //   this.$toast.error('Apólice obrigatoria!')
        //   this.store.currentTab = oldValue;
        // }
        // if (!this.form.cnpj_compania) {
        //   this.$toast.error('CNPJ da compania obrigatoria!')
        //   this.store.currentTab = oldValue;
        // }
        this.store.formData = {
          ...this.store.formData,
          seguro: [{
            ...this.form,
            tipo_responsavel: this.form.tipo_responsavel.id,
            averbacoes: this.form.averbacoes,
          }]
        }
      }
    },
  }
}

